import script from "./InsertSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./InsertSuccess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__